'use es6';

// TODO: When all CMS editors are on Quartz, update this library to be quartz-exclusive and use getHistory from quartz-routing/service instead
// @bend-expect quartz-no-create-browser-history
import { createBrowserHistory } from 'quartz-routing/react-router';
import { setHistory } from './getHistory';
const createHistory = rootUrl => {
  const routerHistory = createBrowserHistory({
    basename: rootUrl
  });
  setHistory(routerHistory);
  return routerHistory;
};
export default createHistory;